import React from "react"
import classNames from "classnames"

import Header from "components/Header"
import Footer from "components/Footer"

import "./SimplePage.sass"

export default function SimplePage({ children, className, isTinted, ...rest }) {
  const simplePageClassName = classNames({
    SimplePage: true,
    [className]: !!className,
    isTinted,
  })
  return (
    <>
      <div id="header-root" className="isDetail">
        <Header isSlim isDetail />
      </div>

      <div className={simplePageClassName} {...rest}>
        <div className="row">
          <div className="full">{children}</div>
        </div>
      </div>

      <Footer />
    </>
  )
}
